import { connect } from 'react-redux';

import PayOff from '../components/payOff';
import {snackBarMessages} from '../const/commonConst'

import {
	postPayOffGenerator,
	postPayOffGeneratorSuccess,
	postPayOffGeneratorFailure,
	getPayOffDownload,
	getPayOffDownloadSuccess,
	getPayOffDownloadFailure,
	downloadTemplateFile,
	redirectFromPayOff,
	postDocumentUpload
} from '../actions/payOffAction';

import {
	showLoader,
	hideLoader
} from '../actions/loaderAction';

import {
	showSnackbar,
	errorSnackbar
} from '../actions/customSnackBarAction';


export const mapStateToProps = (state)=>{
    return {
		loading: state.loader.status,
		assetDetails: state.assetDetailsReducer.assetDetails,
		//assetDetails: {payoffInfo: {"assetDetails":[{"id":0,"paymentPlanId":0,"assetId":"OH20000314CC","lienOriginationDate":"2020-11-20T00:00:00","lienExpirationDate":null,"currentInterestRate":17.0,"taxAmount":45572.91,"interestAndPenalty":2734.37,"interestBearingRecoverableFee":0.0,"recoverableFee":0.0,"redemptiveValue":48307.28,"balanceTypeCode":0,"balanceType":null,"lienOriginationDateString":"11-20-2020","lienExpirationDateString":"","rowNo":1,"typeCode":1,"type":"CurrentBalance","projectedFee":0.0,"maxTerms":0,"maxDownPayment":144921.84,"maxBaloonPayment":136718.73,"minimumPlanStartDate":"2021-04-01T00:00:00","totalAdditionalFee":0.0,"totalTransactionsFee":0.0,"isForeclosureActivated":false,"isThirdPartyForeclosureActivated":false,"isBankruptcyActivated":false,"firstPaymentDate":null,"downPaymentDate":null,"downPaymentAmount":0.0,"lastPaymentDate":null,"monthlyPayAmount":0.0,"lastPayAmount":0.0,"isActive":false,"isDeleted":false,"createdDate":"0001-01-01T00:00:00","createdBy":"00000000-0000-0000-0000-000000000000","updatedDate":"0001-01-01T00:00:00","updatedBy":null,"createdByUserInitial":null,"updatedByUserInitial":null,"isVisible":false},{"id":0,"paymentPlanId":0,"assetId":"OH20000338CC","lienOriginationDate":"2020-11-20T00:00:00","lienExpirationDate":null,"currentInterestRate":17.0,"taxAmount":91145.82,"interestAndPenalty":5468.74,"interestBearingRecoverableFee":0.0,"recoverableFee":0.0,"redemptiveValue":96614.56,"balanceTypeCode":0,"balanceType":null,"lienOriginationDateString":"11-20-2020","lienExpirationDateString":"","rowNo":2,"typeCode":1,"type":"CurrentBalance","projectedFee":0.0,"maxTerms":0,"maxDownPayment":144921.84,"maxBaloonPayment":136718.73,"minimumPlanStartDate":"2021-04-01T00:00:00","totalAdditionalFee":0.0,"totalTransactionsFee":0.0,"isForeclosureActivated":false,"isThirdPartyForeclosureActivated":false,"isBankruptcyActivated":false,"firstPaymentDate":null,"downPaymentDate":null,"downPaymentAmount":0.0,"lastPaymentDate":null,"monthlyPayAmount":0.0,"lastPayAmount":0.0,"isActive":false,"isDeleted":false,"createdDate":"0001-01-01T00:00:00","createdBy":"00000000-0000-0000-0000-000000000000","updatedDate":"0001-01-01T00:00:00","updatedBy":null,"createdByUserInitial":null,"updatedByUserInitial":null,"isVisible":false}],"projectedFee":0.0,"maxTerms":0,"maxDownPayment":144921.84,"maxBaloonPayment":136718.73,"minimumPlanStartDate":"2021-04-01T00:00:00","totalAdditionalFee":0.0,"totalTransactionsFee":0.0,"isForeclosureActivated":true,"isThirdPartyForeclosureActivated":false,"isBankruptcyActivated":false}}
    }
}

export const mapDispatchToProps = (dispatch) => {
	return {
        postPayOffGenerator: (request) => {
			return new Promise((resolve, reject) => {
				try {
                    dispatch(showLoader())
					dispatch(postPayOffGenerator(request))
						.then((response) => {
							dispatch(postPayOffGeneratorSuccess(response.payload.data))
                            resolve(response.payload.data)
							dispatch(hideLoader())
							dispatch(showSnackbar(snackBarMessages.showfileDownloadMsg))
						})
						.catch((error) => {
                            dispatch(postPayOffGeneratorFailure(error))
							dispatch(hideLoader())
							dispatch(errorSnackbar(snackBarMessages.error))
						})
				} catch (error) {
					reject(error)
				}
			})
		},
		getPayOffDownload: (id) => {
			return new Promise((resolve, reject) => {
				try {
					// dispatch(showLoader())
					dispatch(getPayOffDownload(id))
						.then((response) => {
							dispatch(getPayOffDownloadSuccess(response.payload.data))
							resolve(response.payload.data)
							//dispatch(hideLoader())
						})
						.catch((error) => {
							dispatch(getPayOffDownloadFailure(error))
							// dispatch(hideLoader())
						})
				} catch (error) {
					reject(error)
				}
			})
		},
		downloadTemplateFile: (url, fileName) => {
            dispatch(downloadTemplateFile(url, fileName))
        },
		redirectFromPayOff: (assetIds) => {
            dispatch(redirectFromPayOff(assetIds))
        },
		postDocumentUpload: (request) => {
            dispatch(postDocumentUpload(request))
        },
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PayOff);